import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplaySkeleton } from 'app/agriculture/components/StatDisplay/StatDisplaySkeleton';

export function FirmwareDisplaySkeleton() {
    return (
        <ContentBox.Section heading="Latest Firmware Update" disableDivider>
            <SimpleGrid className="FirmwareDisplay" columns={3}>
                <StatDisplaySkeleton label="Package name" />
                <StatDisplaySkeleton label="Package version" />
                <StatDisplaySkeleton label="State" />
                <StatDisplaySkeleton label="Update delivery method" />
                <StatDisplaySkeleton label="Update result" />
            </SimpleGrid>
        </ContentBox.Section>
    );
}
